import React from "react"
import game from "damas.png"

const Damas = props => <img src={game} className="game" {...props} />

export default Damas
